import { useState, useEffect } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage, FilterDatePicker } from '../../common/Forms/Input/Input.jsx';
import { CasheaLinkDeletedOrdersTable } from '../../common/Tables/Tables.jsx';
import { casheaLinkDeletedOrdersTableHeader } from '../../../assets/helpers/tables.js';
import { notify } from '../../../assets/helpers/toast.js';
import moment from 'moment';
import { filterParams } from '../../../assets/helpers/funciones.js';
import './CasheaLinkDeletedOrders.scss';
import { casheaLinkService } from '../../../services/casheaLinkService.js';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];

export const CasheaLinkDeletedOrders = () => {
  const [dateFrom, setDateFrom] = useState(
    new Date(moment().subtract(1, 'months'))
  );
  const [dateTo, setDateTo] = useState(new Date(moment()));
  const [casheaLinkDeletedOrdersTable, setCasheaLinkDeletedOrdersTable] =
    useState({
      limit: itemsPerpage[2],
      data: [],
      count: 0,
      page: 1,
      isLoading: false,
    });

  const setFirstPage = () => {
    setCasheaLinkDeletedOrdersTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setDateTo(e);
      setFirstPage();
    }
  };

  const selectitemsPerpage = (event) => {
    setCasheaLinkDeletedOrdersTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setCasheaLinkDeletedOrdersTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * casheaLinkDeletedOrdersTable?.limit,
      };
    });
  };

  useEffect(() => {
    getDeletedOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    casheaLinkDeletedOrdersTable?.page,
    casheaLinkDeletedOrdersTable?.offset,
    casheaLinkDeletedOrdersTable?.limit,
    dateFrom,
    dateTo,
  ]);

  const getDeletedOrders = () => {
    let params = {
      dateFrom: dateFrom
        ? moment(dateFrom).format('MM-DD-YYYY')
        : moment().subtract(1, 'months').format('MM-DD-YYYY'),
      dateTo: dateTo
        ? moment(dateTo).format('MM-DD-YYYY')
        : moment().format('MM-DD-YYYY'),
      limit: casheaLinkDeletedOrdersTable?.limit,
      offset: casheaLinkDeletedOrdersTable?.offset,
    };

    casheaLinkService
      .listDeletedOrders(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setCasheaLinkDeletedOrdersTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.orders,
              count: response?.data?.total,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || 'error', 'error');
          setCasheaLinkDeletedOrdersTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => {
        setCasheaLinkDeletedOrdersTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  return (
    <>
      <Header />
      <LoadSpinner show={casheaLinkDeletedOrdersTable?.isLoading} />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">{`Cashea Link: ${casheaLinkDeletedOrdersTable.count}`}</h1>
        </div>
        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <FilterDatePicker
                bootstrap={'col-12 col-md-2'}
                label={'Desde'}
                type={'date'}
                name={'dateFrom'}
                placeholder={''}
                onChange={handleSinceDateChange}
                value={dateFrom}
                disabled={casheaLinkDeletedOrdersTable?.isLoading}
              />
              <FilterDatePicker
                bootstrap={'col-12 col-md-2'}
                label={'Hasta'}
                type={'date'}
                name={'dateTo'}
                placeholder={''}
                onChange={handleUntilDateChange}
                value={dateTo}
                disabled={casheaLinkDeletedOrdersTable?.isLoading}
              />
              <div
                style={{
                  marginTop: '24px',
                  marginLeft: 'auto',
                  width: '350px',
                }}
              >
                <SelectPerPage
                  label={'Registros por página'}
                  options={itemsPerpage}
                  value={casheaLinkDeletedOrdersTable?.limit}
                  onChange={selectitemsPerpage}
                />
              </div>
            </div>
          </div>
        </div>
        <CasheaLinkDeletedOrdersTable
          header={casheaLinkDeletedOrdersTableHeader}
          data={casheaLinkDeletedOrdersTable}
          handlePageChange={handlePageChange}
        />
      </div>
    </>
  );
};
